var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.27 21C10.6269 21.6188 11.2863 22 12 22C12.7137 22 13.3732 21.6188 13.73 21",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17798 15.326C2.90851 15.6185 2.83872 16.041 3 16.4034C3.16128 16.7658 3.52325 16.9997 3.92305 17H20.0763C20.4761 17.0001 20.8383 16.7666 21 16.4045C21.1617 16.0424 21.0925 15.6199 20.8234 15.327C19.4807 13.956 18.0572 12.499 18.0572 8C18.0572 4.68629 15.3452 2 11.9997 2C8.65424 2 5.94221 4.68629 5.94221 8C5.94221 12.499 4.5177 13.956 3.17798 15.326Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.5473c0521a5af6c17e7ec590b832d183.svg";
export { ForwardRef as ReactComponent };